import Layout from '../../internal/Layout.vue'
import ExternalFileControlPage from './externalFileControl/externalFileControl.vue'

const ExternalFileControlRoutes = {
  component: Layout,
  children: [
    {
      name: 'externalFileControl',
      path: '/',
      component: ExternalFileControlPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresLaboratory: true,
      },
    },
  ],
}

export default ExternalFileControlRoutes
